export default __webpack_public_path__ + "static/media/check.7c6abd4e.svg";